import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';

import { Currency as CurrencyField } from 'gw-components-platform-react';
import { IntlContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { Icon } from "@jutro/components";
import moment from 'moment';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { DocumentDownloadService } from '@xengage/gw-portals-document-js';
import DocumentService from '../../../../../common/capabilities/gw-capability-policydocument/services/DocumentService';
import metadata from './PayrollDocumentsTable.metadata.json5';
import styles from './PayrollDocumentsTable.module.scss';
import messages from './PayrollDocumentsTable.messages';


import { Link } from '@jutro/router';


const renderFormattedCurrencyField = (item, index) => {
    return (
        <div className={styles.currencyContainer}>
            <CurrencyField
                id={`currency_${index}`}
                value={item}
                readOnly
                hideLabel
            />
        </div>
    );
};

const getFormattedCurrency = (item, index, property) => {
    return renderFormattedCurrencyField(item[property.id]);
};

const getCell = (item, index, property) => {
    return item[property.id];
};



function PayrollDocumentsTable(props) {
    const {
        payrollData
        
    } = props;
 

    const intl = useContext(IntlContext);

    const getFormattedDate = useCallback((item, index, property) => {
        return  moment(item[property.id]).format('MM/DD/YYYY');
    }, []);

   
    const getPDF = (item, index, property) => {
        return (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <button
                id={index}
                onClick={(e) => {
                    // console.log(item);
                    e.preventDefault()
                    window.open(DocumentService.downloadPolicyDocument(item.docUID,item.sessionID))
                    //const a = document.createElement("a");
                    // a.setAttribute("href", res);
                    // document.body.appendChild(a);
                   // a.click();
                }}
                    
                            
                style={{ display: "block" }}
                className={styles.PDFButton}
            >
                <Icon icon="cust-file-solid" />
                PDF
            </button>
        );
    };


    

    

    const overrideProps = {
        tablePaymentScheduleDetail: {
            data: payrollData
        },
       
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getFormattedDate,
            getFormattedCurrency,
            getCell,
            getPDF
            
        }
    };

    return <MetadataContent uiProps={metadata.componentContent} overrideProps={overrideProps} {...resolvers} />;
}

PayrollDocumentsTable.propTypes = {
    payrollData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    
};

PayrollDocumentsTable.defaultProps = {
   
};

export default PayrollDocumentsTable;
